import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import GNALogo from "@/assets/gna_logo.png";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'Home', to: '/' },
    { label: 'Schedule', to: '/schedule' },
    { label: 'Speakers', to: '/speakers' },
    { label: 'Register', to: '/register' },
    { label: 'Premium', to: '/premium' },
  ];

  const transparent = isHome && !scrolled;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        transparent ? 'bg-transparent' : 'bg-white/95 backdrop-blur-md shadow-sm'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center justify-between h-16 md:h-20">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3 cursor-pointer">
          <img
            src={GNALogo}
            alt="GNA Logo"
            className="h-10 md:h-12 w-auto object-contain"
          />
        </Link>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => {
            const active = location.pathname === link.to;
            return (
              <Link
                key={link.label}
                to={link.to}
                className={`text-sm font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap ${
                  transparent
                    ? active ? 'text-white font-bold' : 'text-white/80 hover:text-white'
                    : active ? 'text-green-700 font-bold' : 'text-gray-700 hover:text-green-700'
                }`}
              >
                {link.label}
              </Link>
            );
          })}
        </div>

        {/* CTA Buttons */}
        <div className="hidden md:flex items-center gap-3">
          <Link
            to="/register"
            className={`px-5 py-2 rounded-full text-sm font-semibold border transition-all duration-200 cursor-pointer whitespace-nowrap ${
              transparent
                ? 'border-white text-white hover:bg-white/10'
                : 'border-green-700 text-green-700 hover:bg-green-50'
            }`}
          >
            Register Free
          </Link>
          <Link
            to="/premium"
            className="px-5 py-2 rounded-full text-sm font-semibold bg-gradient-to-r from-green-700 to-green-800 text-white hover:opacity-90 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            Go Premium
          </Link>
        </div>

        {/* Mobile Hamburger */}
        <button
          className={`md:hidden w-8 h-8 flex items-center justify-center cursor-pointer ${transparent ? 'text-white' : 'text-gray-800'}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={`text-xl ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white/98 backdrop-blur-md border-t border-gray-100 px-4 py-4 flex flex-col gap-3">
          {navLinks.map((link) => (
            <Link
              key={link.label}
              to={link.to}
              onClick={() => setMenuOpen(false)}
              className={`font-medium py-2 border-b border-gray-100 cursor-pointer ${
                location.pathname === link.to ? 'text-green-700 font-bold' : 'text-gray-700'
              }`}
            >
              {link.label}
            </Link>
          ))}
          <div className="flex flex-col gap-2 pt-2">
            <Link
              to="/register"
              onClick={() => setMenuOpen(false)}
              className="text-center px-5 py-2.5 rounded-full text-sm font-semibold border border-green-700 text-green-700 cursor-pointer whitespace-nowrap"
            >
              Register Free
            </Link>
            <Link
              to="/premium"
              onClick={() => setMenuOpen(false)}
              className="text-center px-5 py-2.5 rounded-full text-sm font-semibold bg-gradient-to-r from-green-700 to-green-800 text-white cursor-pointer whitespace-nowrap"
            >
              Go Premium – $120
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
